@if (vm$ | async; as vm) {
  <mat-toolbar>
    <div class="left-side">
      @if (vm.signedIn) {
        <button
          mat-icon-button
          aria-label="Toggle navigation menu"
          matTooltip="Menu"
          (click)="menuClick.emit()"
        >
          <mat-icon>menu</mat-icon>
        </button>
      }
    </div>

    <div class="middle">
      <a
        [routerLink]="vm.signedIn ? ['/home'] : []"
        [style.cursor]="vm.signedIn ? 'pointer' : 'default'"
        class="logo-link"
      >
        <img src="assets/images/logo-reverse.png" alt="JFW logo" />
      </a>
      <div class="wordmark">
        <span class="wordmark-title">Platform Portal</span>
      </div>
    </div>

    <div class="center-search">
      @if (vm.signedIn) {
        <app-module-search></app-module-search>
      }
    </div>

    <div class="right-side">
      @if (vm.signedIn) {
        @if (enableFeedback) {
          <button
            mat-icon-button
            type="button"
            class="feedback-button"
            aria-label="Send feedback"
            matTooltip="Send feedback"
            (click)="openFeedback()"
          >
            <mat-icon>campaign</mat-icon>
          </button>
        }
        <app-language-switcher
          class="language-switcher"
          [language]="activeLanguage()"
          (languageChange)="onLanguageChange($event)"
        />
        <button
          mat-icon-button
          [matMenuTriggerFor]="accountMenu"
          class="account-button"
          aria-label="Account menu"
          matTooltip="Account"
        >
          @if (vm.photoUrl && vm.photoUrl !== failedPhotoUrl()) {
            <img
              [src]="vm.photoUrl"
              alt=""
              (error)="onPhotoError(vm.photoUrl)"
            />
          } @else {
            <mat-icon>account_circle</mat-icon>
          }
        </button>
        <span class="user-name">{{ vm.displayName }}</span>
        <mat-menu #accountMenu="matMenu">
          <!-- EXT-6562: dark mode setting, IT department only. Clicks stay
               inside so choosing an option doesn't close the menu. -->
          @if (themeService.isAvailable()) {
            <div
              class="appearance"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
            >
              <span class="appearance-label" id="appearance-label"
                >Appearance</span
              >
              <mat-button-toggle-group
                class="appearance-options"
                aria-labelledby="appearance-label"
                hideSingleSelectionIndicator
                [value]="themeService.preference()"
                (change)="themeService.setPreference($event.value)"
              >
                <mat-button-toggle value="light">
                  <mat-icon>light_mode</mat-icon>Light
                </mat-button-toggle>
                <mat-button-toggle value="dark">
                  <mat-icon>dark_mode</mat-icon>Dark
                </mat-button-toggle>
                <mat-button-toggle value="system">
                  <mat-icon>computer</mat-icon>System
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>
            <mat-divider />
          }
          <a mat-menu-item routerLink="/my-profile">
            <mat-icon>person</mat-icon>My Profile
          </a>
          @if (enableFeedback) {
            <a mat-menu-item routerLink="/my-feedback">My Feedback</a>
          }
          <button mat-menu-item (click)="signOutClick$.next()">Sign Out</button>
        </mat-menu>
      }
    </div>

    @if (servedEnvironment === "local") {
      <div class="local-site">Local</div>
    } @else if (servedEnvironment === "dev") {
      <div class="dev-site">Dev</div>
    } @else if (servedEnvironment === "test") {
      <div class="test-site">Test</div>
    }
  </mat-toolbar>
}
